export default "__VITE_ASSET__BPfiYBjL__"